import { render, staticRenderFns } from "./DocumentTypeTaxonomyList.vue?vue&type=template&id=6c20d074&"
import script from "./DocumentTypeTaxonomyList.vue?vue&type=script&lang=ts&"
export * from "./DocumentTypeTaxonomyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports